import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex" }
const _hoisted_2 = {
  id: "schoolday_sis_form",
  class: "w-full"
}
const _hoisted_3 = { class: "field" }
const _hoisted_4 = { class: "field" }
const _hoisted_5 = { class: "field" }
const _hoisted_6 = { class: "field" }
const _hoisted_7 = { class: "flex field" }
const _hoisted_8 = { class: "flex flex-none mx-3" }
const _hoisted_9 = {
  key: 0,
  class: "flex"
}
const _hoisted_10 = { class: "flex flex-none mx-3" }
const _hoisted_11 = {
  key: 0,
  class: "flex justify-content-end mt-4 pb-4 pl-2 pr-2"
}
const _hoisted_12 = {
  key: 1,
  class: "flex justify-content-end mt-4 pb-5 pl-2 pr-2"
}

import { ref, computed, onMounted } from 'vue';
import { storeToRefs } from 'pinia';
import { required } from '@vuelidate/validators';
import { useRouting, useValidation } from '@/composables';
import { SIS_PROVIDER_SLUG } from '@/enum';
import { IntegrationSchoolDayService } from '@/services';
import { useTenantIntegrationStore } from '@/store';
import SchoolDaySISOrganizations from './SchoolDaySISOrganizations.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'SchoolDaySIS',
  setup(__props) {

const tenantIntegrationStore = useTenantIntegrationStore();

const { error } = storeToRefs(tenantIntegrationStore);

const $routing = useRouting();

const $validation = useValidation();

const isLoading = computed(() => tenantIntegrationStore.loading);

const rules = {
  hostUrl: { required },
  hostAuthUrl: { required },
  clientId: { required },
  secretKey: { required },
  enableSync: { required: false },
  archiveAfter: { required },
};

const payload = ref({
  hostUrl: '',
  hostAuthUrl: '',
  clientId: '',
  secretKey: '',
  enableSync: false,
  archiveAfter: 30,
});

const $v = $validation.defineValidation(rules, payload);

const tenantId = ref(Number($routing.route.params.id));

const integration = ref();

const integrationStatus = ref(null);

const integrationStatusStyles = computed(() => {
  if (integrationStatus.value === null) return 'ml-2 text-lg text-gray';
  return `ml-2 text-lg ${integrationStatus.value ? 'text-green' : 'text-color-red'}`;
});

onMounted(async () => await init());

const init = async () => {
  defineIntegrationStatus();
  defineIntegration();
};

const defineIntegrationStatus = async () => {
  const status = await IntegrationSchoolDayService.status(tenantId.value);
  integrationStatus.value = status.data;
};

const defineIntegration = () => {
  integration.value = tenantIntegrationStore.findIntegration(SIS_PROVIDER_SLUG.SCHOOLDAY);

  if (integration.value) {
    payload.value = {
      id: integration.value.id,
      hostUrl: integration.value.data.host_url,
      hostAuthUrl: integration.value.data.host_auth_url,
      clientId: integration.value.data.client_id,
      secretKey: integration.value.data.secret_key,
      enableSync: integration.value.data.can_sync,
      archiveAfter: !integration.value.data.archive_after
        ? payload.value.archiveAfter
        : integration.value.data.archive_after,
    };
  }
};

const onCancel = () => {
  init();
  $validation.resetDirty();
};

const onSave = async () => {
  if ($v.value.$invalid) return;

  const formData = new FormData();
  const configData = JSON.stringify({
    host_url: payload.value.hostUrl,
    host_auth_url: payload.value.hostAuthUrl,
    client_id: payload.value.clientId,
    secret_key: payload.value.secretKey,
    can_sync: payload.value.enableSync,
    archive_after: payload.value.archiveAfter,
  });

  formData.append('data', configData);
  formData.append('integration_provider_type_slug', SIS_PROVIDER_SLUG.SCHOOLDAY);

  payload.value.id
    ? await tenantIntegrationStore.updateTenantIntegration(tenantId.value, payload.value.id, formData)
    : await tenantIntegrationStore.saveTenantIntegration(tenantId.value, formData);

  if (!error.value) {
    await init();
    $validation.resetDirty();
  }
};

return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Password = _resolveComponent("Password")!
  const _component_InputSwitch = _resolveComponent("InputSwitch")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, null, {
    header: _withCtx(() => [
      _cache[7] || (_cache[7] = _createElementVNode("div", { class: "flex" }, [
        _createElementVNode("h2", { class: "m-0" }, "SchoolDay OneRoster")
      ], -1)),
      _cache[8] || (_cache[8] = _createElementVNode("div", { class: "flex flex-grow-1" }, null, -1)),
      _createElementVNode("div", _hoisted_1, [
        _cache[6] || (_cache[6] = _createElementVNode("span", null, "Integration Status", -1)),
        _createVNode(_component_Icon, {
          name: "circle",
          class: _normalizeClass(integrationStatusStyles.value)
        }, null, 8, ["class"])
      ])
    ]),
    content: _withCtx(() => [
      _createElementVNode("form", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[9] || (_cache[9] = _createElementVNode("label", {
            for: "host-url",
            class: "required"
          }, "Host URL", -1)),
          (isLoading.value)
            ? (_openBlock(), _createBlock(_component_Skeleton, {
                key: 0,
                height: "2.3rem"
              }))
            : (_openBlock(), _createBlock(_component_InputText, {
                key: 1,
                id: "host-url",
                modelValue: _unref($v).hostUrl.$model,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref($v).hostUrl.$model) = $event)),
                class: _normalizeClass(_unref($validation).fieldStyles('hostUrl', 'w-full')),
                placeholder: "Enter Host URL",
                autocomplete: "off"
              }, null, 8, ["modelValue", "class"]))
        ]),
        _createElementVNode("div", _hoisted_4, [
          _cache[10] || (_cache[10] = _createElementVNode("label", {
            for: "host-auth-url",
            class: "required"
          }, "Host Auth URL", -1)),
          (isLoading.value)
            ? (_openBlock(), _createBlock(_component_Skeleton, {
                key: 0,
                height: "2.3rem"
              }))
            : (_openBlock(), _createBlock(_component_InputText, {
                key: 1,
                id: "host-auth-url",
                modelValue: _unref($v).hostAuthUrl.$model,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref($v).hostAuthUrl.$model) = $event)),
                class: _normalizeClass(_unref($validation).fieldStyles('hostAuthUrl', 'w-full')),
                placeholder: "Enter Host Auth URL",
                autocomplete: "off"
              }, null, 8, ["modelValue", "class"]))
        ]),
        _createElementVNode("div", _hoisted_5, [
          _cache[11] || (_cache[11] = _createElementVNode("label", {
            for: "client-id",
            class: "required"
          }, "Client ID", -1)),
          (isLoading.value)
            ? (_openBlock(), _createBlock(_component_Skeleton, {
                key: 0,
                height: "2.3rem"
              }))
            : (_openBlock(), _createBlock(_component_Password, {
                key: 1,
                id: "client-id",
                modelValue: _unref($v).clientId.$model,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref($v).clientId.$model) = $event)),
                "toggle-mask": true,
                class: _normalizeClass(_unref($validation).fieldStyles('clientId', 'w-full')),
                "input-class": "w-full",
                placeholder: "Enter Client ID",
                feedback: false,
                autocomplete: "off"
              }, null, 8, ["modelValue", "class"]))
        ]),
        _createElementVNode("div", _hoisted_6, [
          _cache[12] || (_cache[12] = _createElementVNode("label", {
            for: "client-secret",
            class: "required"
          }, "Secret Key", -1)),
          (isLoading.value)
            ? (_openBlock(), _createBlock(_component_Skeleton, {
                key: 0,
                height: "2.3rem"
              }))
            : (_openBlock(), _createBlock(_component_Password, {
                key: 1,
                id: "secret-key",
                modelValue: _unref($v).secretKey.$model,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref($v).secretKey.$model) = $event)),
                "toggle-mask": true,
                class: _normalizeClass(_unref($validation).fieldStyles('secretKey', 'w-full')),
                "input-class": "w-full",
                placeholder: "Enter Secret Key",
                feedback: false,
                autocomplete: "off"
              }, null, 8, ["modelValue", "class"]))
        ]),
        _createElementVNode("div", _hoisted_7, [
          _cache[15] || (_cache[15] = _createElementVNode("div", { class: "flex flex-none my-2" }, [
            _createElementVNode("label", { for: "enable-automated-data-synchronization" }, "Enable Automated Data Synchronization")
          ], -1)),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_InputSwitch, {
              modelValue: _unref($v).enableSync.$model,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref($v).enableSync.$model) = $event))
            }, null, 8, ["modelValue"])
          ]),
          (_unref($v).enableSync.$model)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _cache[14] || (_cache[14] = _createElementVNode("div", { class: "flex flex-none my-2" }, [
                  _createElementVNode("label", { for: "enable-automated-data-synchronization" }, "Archive After")
                ], -1)),
                _createElementVNode("div", _hoisted_10, [
                  (isLoading.value)
                    ? (_openBlock(), _createBlock(_component_Skeleton, {
                        key: 0,
                        height: "2.3rem"
                      }))
                    : (_openBlock(), _createBlock(_component_InputNumber, {
                        key: 1,
                        id: "archive-after",
                        modelValue: _unref($v).archiveAfter.$model,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref($v).archiveAfter.$model) = $event)),
                        min: 0,
                        max: 50,
                        class: _normalizeClass(_unref($validation).fieldStyles('archiveAfter')),
                        placeholder: "Days",
                        autocomplete: "off"
                      }, null, 8, ["modelValue", "class"])),
                  _cache[13] || (_cache[13] = _createElementVNode("span", {
                    class: "m-2",
                    textContent: 'Days'
                  }, null, -1))
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        (_unref($validation).anyDirty() && !_unref(tenantIntegrationStore).openModal)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _cache[16] || (_cache[16] = _createElementVNode("div", { class: "flex w-full mt-3 mr-4 border-top-1 border-primary-500" }, null, -1)),
              _createVNode(_component_AppButton, {
                type: "secondary",
                class: "mr-3",
                text: "Cancel",
                onClick: onCancel
              }),
              _createVNode(_component_AppButton, {
                type: "primary",
                text: "Save",
                onClick: onSave
              })
            ]))
          : _createCommentVNode("", true),
        ((integration.value && !_unref($validation).anyDirty()) || _unref(tenantIntegrationStore).openModal)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [...(_cache[17] || (_cache[17] = [
              _createElementVNode("div", { class: "flex w-full mt-3 border-top-1 border-primary-500" }, null, -1)
            ]))]))
          : _createCommentVNode("", true)
      ]),
      (integration.value)
        ? (_openBlock(), _createBlock(SchoolDaySISOrganizations, {
            key: 0,
            integration: integration.value
          }, null, 8, ["integration"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})